import { useNavigate } from "react-router-dom";
import { PasswordResetForm } from "@/components/auth/PasswordResetForm";
import { AuthLayout } from "@/components/auth/AuthLayout";

const ResetPassword = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/dashboard");
  };

  return (
    <AuthLayout
      heading="Resetează parola"
      leftContent={
        <>
          <p className="font-heading text-sm text-ds-text-500 -mt-2">
            Introdu noua ta parolă pentru a-ți reseta accesul la cont.
          </p>
          <PasswordResetForm
            onSuccess={handleSuccess}
            submitButtonText="Resetează parola"
          />
          <div className="text-center">
            <button
              onClick={() => navigate("/auth")}
              className="font-heading text-sm text-ds-blue-600 hover:underline"
            >
              Înapoi la autentificare
            </button>
          </div>
        </>
      }
      rightContent={
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-4">
            <h2 className="font-heading text-[32px] font-bold text-white leading-[1.2]">
              Securitatea contului tău
            </h2>
            <p className="font-heading text-sm text-ds-blue-200 leading-[1.6]">
              Alege o parolă puternică pentru a-ți proteja datele și progresul în
              evaluarea NIS2.
            </p>
          </div>

          <div className="flex flex-col gap-4 p-5 rounded-xl border border-ds-border-800 bg-white/[0.03]">
            <p className="font-heading text-sm font-semibold text-white">
              Sfaturi pentru o parolă sigură:
            </p>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-3">
                <span className="font-heading text-ds-green-500 text-sm">✓</span>
                <span className="font-heading text-ds-xsm text-ds-text-400 leading-[1.4]">
                  Minimum 6 caractere (recomandat 12+)
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="font-heading text-ds-green-500 text-sm">✓</span>
                <span className="font-heading text-ds-xsm text-ds-text-400 leading-[1.4]">
                  Combină litere mari și mici
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="font-heading text-ds-green-500 text-sm">✓</span>
                <span className="font-heading text-ds-xsm text-ds-text-400 leading-[1.4]">
                  Include numere și caractere speciale
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="font-heading text-ds-green-500 text-sm">✓</span>
                <span className="font-heading text-ds-xsm text-ds-text-400 leading-[1.4]">
                  Evită cuvinte comune sau informații personale
                </span>
              </li>
            </ul>
          </div>
        </div>
      }
    />
  );
};

export default ResetPassword;
